module.exports = __webpack_public_path__ + "static/media/antyzamrozenie.4bf324ed.svg";